import {
    createContext,
    useContext
} from "react";
import type {
    MarkdownEditorHeadingContextType
} from "./type";

export const MarkdownEditorHeadingContext = createContext<MarkdownEditorHeadingContextType>({
    isOpen: false
});

export const useMarkdownEditorHeadingContext = (): MarkdownEditorHeadingContextType => {
    return useContext(MarkdownEditorHeadingContext);
};
